import { render, staticRenderFns } from "./BibliographyEditor.vue?vue&type=template&id=70668c19&scoped=true&"
import script from "./BibliographyEditor.vue?vue&type=script&lang=js&"
export * from "./BibliographyEditor.vue?vue&type=script&lang=js&"
import style0 from "./BibliographyEditor.vue?vue&type=style&index=0&id=70668c19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70668c19",
  null
  
)

export default component.exports